var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.432,
    height: 86.884,
    viewBox: "0 0 101.432 86.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66264",
    "data-name": "Path 66264",
    d: "M119.161,109.79H34.308a4.726,4.726,0,0,1-3.925-7.2L72.4,32.686a4.553,4.553,0,0,1,7.83-.035l42.837,69.9A4.726,4.726,0,0,1,119.161,109.79Z",
    transform: "translate(-26.016 -26.673)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66265",
    "data-name": "Path 66265",
    d: "M93.372,87.08H8.519a8.088,8.088,0,0,1-4.3-1.238,8.4,8.4,0,0,1-2.9-3.1,8.591,8.591,0,0,1,.177-8.56L43.5,4.283A8.164,8.164,0,0,1,50.5.26h.037a8.18,8.18,0,0,1,6.991,3.96l42.837,69.905a8.64,8.64,0,0,1,.233,8.59,8.227,8.227,0,0,1-7.225,4.365ZM50.535,7.73h0a.921.921,0,0,0-.817.47L7.7,78.1a.96.96,0,0,0-.02,1,.915.915,0,0,0,.842.506H93.372a.917.917,0,0,0,.844-.51.963.963,0,0,0-.027-1L51.352,8.193a.918.918,0,0,0-.817-.463Z",
    transform: "translate(-0.227 -0.228)",
    fill: "#c50f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66266",
    "data-name": "Path 66266",
    d: "M93.144,86.884H8.291a8.119,8.119,0,0,1-4.32-1.238,8.435,8.435,0,0,1-2.912-3.112,8.621,8.621,0,0,1,.178-8.591l42.013-69.9A8.2,8.2,0,0,1,50.27,0h.038a8.2,8.2,0,0,1,7.018,3.976l42.837,69.9A8.67,8.67,0,0,1,100.4,82.5a8.259,8.259,0,0,1-7.252,4.382ZM50.308.064h-.037A8.135,8.135,0,0,0,43.3,4.071L1.291,73.975A8.565,8.565,0,0,0,1.113,82.5,8.4,8.4,0,0,0,4.006,85.6,8.064,8.064,0,0,0,8.291,86.82H93.144a8.2,8.2,0,0,0,7.2-4.347,8.609,8.609,0,0,0-.225-8.559L57.272,4.01A8.134,8.134,0,0,0,50.308.064Zm42.836,79.35H8.291a.947.947,0,0,1-.866-.523.99.99,0,0,1,.021-1.031L49.458,7.955A.95.95,0,0,1,50.3,7.47h0a.95.95,0,0,1,.844.478L93.988,77.852a.99.99,0,0,1,.027,1.035.947.947,0,0,1-.871.527ZM50.3,7.534a.889.889,0,0,0-.79.454L7.5,77.892a.933.933,0,0,0-.02.969.889.889,0,0,0,.814.5H93.144a.887.887,0,0,0,.816-.5.934.934,0,0,0-.026-.973L51.1,7.981a.89.89,0,0,0-.79-.447Z",
    transform: "translate(0.001)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66267",
    "data-name": "Path 66267",
    d: "M119.161,109.79H34.308a4.726,4.726,0,0,1-3.925-7.2L72.4,32.686a4.553,4.553,0,0,1,7.83-.035l42.837,69.9A4.726,4.726,0,0,1,119.161,109.79Z",
    transform: "translate(-26.016 -26.673)",
    fill: "#c50f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66268",
    "data-name": "Path 66268",
    d: "M118.907,109.594H34.054a4.579,4.579,0,0,1-4.016-2.37,4.785,4.785,0,0,1,.063-4.878l42.015-69.9a4.594,4.594,0,0,1,3.934-2.262h.02A4.591,4.591,0,0,1,80,32.408l42.837,69.9a4.787,4.787,0,0,1,.094,4.9A4.579,4.579,0,0,1,118.907,109.594ZM76.07,30.244h-.02a4.524,4.524,0,0,0-3.878,2.228L30.16,102.379a4.722,4.722,0,0,0-.062,4.814,4.513,4.513,0,0,0,3.96,2.336h84.849a4.511,4.511,0,0,0,3.97-2.351,4.719,4.719,0,0,0-.093-4.826L79.948,32.441A4.526,4.526,0,0,0,76.07,30.244Z",
    transform: "translate(-25.763 -26.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66269",
    "data-name": "Path 66269",
    d: "M108.345,100.317H23.492A6.037,6.037,0,0,1,18.138,97.1a6.337,6.337,0,0,1,.131-6.358l42.016-69.9a6.064,6.064,0,0,1,5.2-2.989h.027a6.064,6.064,0,0,1,5.2,2.941l42.831,69.9a6.332,6.332,0,0,1,.168,6.376A6.013,6.013,0,0,1,108.345,100.317ZM65.51,20.962h-.015a3.016,3.016,0,0,0-2.616,1.51l-42.013,69.9a3.19,3.19,0,0,0-.066,3.2,3.039,3.039,0,0,0,2.692,1.616h84.853a3.038,3.038,0,0,0,2.7-1.632,3.19,3.19,0,0,0-.087-3.218l-42.837-69.9A3.015,3.015,0,0,0,65.51,20.962Z",
    transform: "translate(-15.2 -15.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66270",
    "data-name": "Path 66270",
    d: "M368.919,157.58c-3.727,0-6.247,5.3-5.7,10.75l3.341,33.413c.083.824,1.143,1.458,2.364,1.458s2.281-.634,2.362-1.458l3.341-33.413C375.166,162.879,372.645,157.58,368.919,157.58Z",
    transform: "translate(-318.203 -138.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4483",
    "data-name": "Ellipse 4483",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "matrix(0.386, -0.922, 0.922, 0.386, 45.953, 71.968)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseForm);
export default __webpack_public_path__ + "static/media/close_form.599ae4e76e49ac9ec0c4db3b887b12c8.svg";
export { ForwardRef as ReactComponent };